import { dataProps } from './properties'

export const setEStoreOrderList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    state.nav.total_amount = payload.total_amount
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setEStoreOrderData = (state, payload) => {
    state.props = payload
} 

export const resetEStoreOrderData = state => {
    state.props = null
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreOrder/mutations.js